import React, {useContext} from "react";
import "react-responsive-modal/styles.css";
import Style from "./bankTransferModal.module.scss";
import {useTranslation} from "react-i18next";
import {CountryCode} from "../reducers/ticket";
import QRCode from "react-qr-code";
import {
    beppoCompanies,
    prepareGiroCodeData
} from "../reusable/functions";
import QRLogo from "../common/assets/qrLogo.png";
import GenericBeppoModal from "./general/genericBeppoModal";
import {TicketDetailsContext} from "./TicketDetailsContext";

interface BankTransferProps {
    onClose: () => void,
    open: boolean,
    title: string,
    totalAmount: string,
    currency?: string
}

const BankTransferModal = (props: BankTransferProps) => {
    const {t} = useTranslation();
    const {
      formattedAmountLabel,
      ticket,
      market: countryCode
    } = useContext(TicketDetailsContext);

    if (!ticket) {
      // early return when no ticket
      return null;
    }

    const {
        iban,
        ibanText,
        ibanSocar,
        ibanSocarText,
        businessName,
        streetName,
        streetNumber,
        postalCode,
        townName,
        country,
        bic,
        bank
    } = beppoCompanies[countryCode];


    const ibanInQR = ticket.parkingZone != null ? iban : ibanSocar ;

    const giroCode = prepareGiroCodeData(bic, businessName, ibanInQR, "EUR", props.totalAmount, ticket.number);

    const qrValue =
        countryCode !== CountryCode.CH
            ? giroCode
            :
        "SPC\n" +
        "0200\n" +
        "1\n" +
        ibanInQR +
        "\n" +
        "S\n" +
        businessName +
        "\n" +
        streetName +
        "\n" +
        streetNumber +
        "\n" +
        postalCode +
        "\n" +
        townName +
        "\n" +
        country +
        "\n" +
        "\n" +
        "\n" +
        "\n" +
        "\n" +
        "\n" +
        "\n" +
        "\n" +
        props.totalAmount +
        "\n" +
        "CHF\n" +
        "\n" +
        "\n" +
        "\n" +
        "\n" +
        "\n" +
        "\n" +
        "\n" +
        "NON\n" +
        "\n" +
        ticket.number +
        "\n" +
        "EPD\n";

  let totalAmount = props.totalAmount;
  if (props.currency) {
    totalAmount = totalAmount + " " + props.currency;
  }
  return (
        <GenericBeppoModal
            title={props.title}
            open={props.open}
            onClose={props.onClose}
        >
            <div className={Style.qrContainer}>
                <div className={Style.qrContainer__title}>
                    {t("TicketDetails.QR title").toString()}
                </div>
                <div className={Style.qrContainer__box}>
                    {countryCode === CountryCode.CH && <img src={QRLogo} alt="qrLogo" className={Style.qrIcon} />}
                    <QRCode value={qrValue} size={150}/>
                </div>
            </div>
            <div className={Style.detailsContainer}>
                <div className={Style.detailsContainer__heading}>
                    {t("TicketDetails.Account details").toString()}
                </div>
                <div>
                    <div className={Style.detailsContainer__paragraphDesktop}>
                        <span>{t("TicketDetails.Account owner").toString()}</span>
                        <div className={Style.detailsContainer__horizontalLine}></div>
                        <span className={Style.detailsContainer__paragraphBold}>
              {businessName}
            </span>
                    </div>
                    <div className={Style.detailsContainer__paragraphDesktop}>
                        <span>IBAN</span>
                        <div className={Style.detailsContainer__horizontalLine}></div>
                        <span className={Style.detailsContainer__paragraphBold}>
              {ticket.parkingZone != null ? ibanText : ibanSocarText}
            </span>
                    </div>
                    <div className={Style.detailsContainer__paragraphDesktop}>
                        <span>BIC</span>
                        <div className={Style.detailsContainer__horizontalLine}></div>
                        <span className={Style.detailsContainer__paragraphBold}>{bic}</span>
                    </div>
                    <div className={Style.detailsContainer__paragraphDesktop}>
                        <span>{t("TicketDetails.Financial institution").toString()}</span>
                        <div className={Style.detailsContainer__horizontalLine}></div>
                        <span className={Style.detailsContainer__paragraphBold}>
              {bank}
            </span>
                    </div>
                    <div className={Style.detailsContainer__paragraphDesktop}>
                        <span>{formattedAmountLabel}</span>
                        <div className={Style.detailsContainer__horizontalLine}></div>
                        <span className={Style.detailsContainer__paragraphBold}>
              {totalAmount}
            </span>
                    </div>
                    <div className={Style.detailsContainer__paragraphDesktop}>
            <span className={Style.detailsContainer__infoTextStyle}>
              {t("TicketDetails.Additional information").toString()}
            </span>
                        <div className={Style.detailsContainer__horizontalLine}></div>
                        <span
                            className={Style.detailsContainer__paragraphBold}
                            style={{color: "#CC0605"}}
                        >
              {ticket.number}
            </span>
                    </div>
                </div>
            </div>
        </GenericBeppoModal>
    );
};

export default BankTransferModal;
